import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable, throwError } from 'rxjs';
import { EventBusService } from './event-bus.service';
import 'rxjs/add/operator/retry';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient,
    private eventBusService: EventBusService) {
  }

  private setHeaders(): HttpHeaders {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    return new HttpHeaders(headersConfig);
  }

  private formatErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.status >= 500) {
      this.eventBusService.conveyErrorOccurred('Something went wrong. Please retry later.');
    }
    return throwError(errorResponse);
  }

  get(path: string, api_url: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${api_url}${path}`, { headers: this.setHeaders(), params })
      .catch((error) => this.formatErrors(error));
  }

  post(path: string, api_url: string, body: any = {}, header: HttpHeaders = this.setHeaders()): Observable<any> {
    return this.http.post(`${api_url}${path}`, body, { headers: header })
      .catch((error) => this.formatErrors(error));
  }

  put(path: string, api_url: string, body: any = {}): Observable<any> {
    return this.http.put(`${api_url}${path}`, body, { headers: this.setHeaders(), responseType: 'text' })
      .catch((error) => this.formatErrors(error));
  }

}
